import { render, staticRenderFns } from "./_totalMiniGameReward.vue?vue&type=template&id=7c09af37&lang=pug"
import script from "./_totalMiniGameReward.vue?vue&type=script&lang=js"
export * from "./_totalMiniGameReward.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports